document.querySelectorAll('.yc-accordion__item--heading').forEach((heading) => {
  heading.addEventListener('click', () => {
    const item = heading.parentElement;
    const group = item.parentElement;

    // 他の item を閉じる
    group.querySelectorAll('.yc-accordion__item').forEach((i) => {
      if (i !== item) i.classList.remove('is-open');
    });

    // クリックした item を開閉
    item.classList.toggle('is-open');
  });
});
